import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpPromotionState implements ICommand
{

	public IsOverBudget : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.IsOverBudget = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.IsOverBudget);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpPromotionState();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'IsOverBudget(B)='+this.IsOverBudget+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50124;
	}

	public getCmdName() : string
	{
		return 'SpPromotionState';
	}

}
